import React, { useContext, useEffect, useState } from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import '../styles/Table.css';

const CriteriaTab = ({ assessmentId }) => {
  const {
    assessment,
    loading,
    criterion,
    deleteCriterion,
    saveCriterion,
    selectCriterion
  } = useContext(AssessmentContext);

  const [answerIndex, setAnswerIndex] = useState(-1);
  const [answerMode, setAnswerMode] = useState('list');
  const [mode, setMode] = useState('list');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [score, setScore] = useState(0);

  useEffect(() => {
    setMode('list');
  }, [assessment]);

  const handleCancel = () => {
    setMode('list'); 
  }

  const handleNew = () => {
    setMode('edit');
    selectCriterion('');
  }

  const handleEditCriterion = async (criterionId) => {
    selectCriterion(criterionId);
    setName(criterion.name);
    setMode('edit');
  }

  const handleSaveAnswer = async () => {
    criterion.answers.push({ description, score });
    setDescription('');
    setScore(0);
  }

  const handleSaveCriterion = async () => {
    criterion.name = name;
    await saveCriterion(criterion);
  }

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      {mode === 'list' && (
        <>
          <button onClick={() => handleNew() }>
            <span role="img" aria-label="add">➕</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'edit' && (
        <>
          <button onClick={() => handleCancel() }>
            <span role="img" aria-label="cancel">❌</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'list' && (
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {assessment.criteria.map((criterion, index) => (
              <tr key={index}>
                <td>{criterion.name}</td>
                <td>
                  <button onClick={() => handleEditCriterion(criterion.id)}>
                    <span role="img" aria-label="edit">✏️</span>
                  </button>
                  <button onClick={() => deleteCriterion(criterion.id)}>
                    <span role="img" aria-label="delete">🗑️</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {mode === 'edit' && (
        <div>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value) }
          />
        </div>
      )}
      {mode === 'edit' && criterion.id && (
        <>
          <br/>
          <h3>Opciones de Respuesta</h3>
          <button onClick={() => { setDescription(''); setScore(0); setAnswerIndex(-1); } }>
            <span role="img" aria-label="add">➕</span>
          </button>
          <table>
            <thead>
              <tr>
                <th>Descripción</th>
                <th>Puntaje</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {criterion.answers.map((answer, index) => (
                <tr key={index}>
                  <td>{answer.description}</td>
                  <td>{answer.score}</td>
                  <td>
                    <button>
                      <span role="img" aria-label="edit">✏️</span>
                    </button>
                    <button>
                      <span role="img" aria-label="delete">🗑️</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <br/>
          <input
            type="text"
            value={description}
            placeholder="Descripción"
            onChange = {(e) => setDescription(e.target.value) }
          />
          <input
            type="number"
            value={score}
            placeholder="Puntaje"
            onChange = {(e) => setScore(e.target.value) }
          />
          <button onClick={() => handleSaveAnswer() }>
            <span role="img" aria-label="save">💾</span>
          </button>
        </>
      )}
      {mode === 'edit' && answerMode === 'list' && (
        <>
          <br/>
          <button onClick={() => handleSaveCriterion() }>
            Grabar
          </button>
        </>
      )}
    </div>
  );
};

export default CriteriaTab;
